module.exports = __webpack_public_path__ + "img/mobile-mens-apparel-banner.a22264fc.jpg";